module.exports = __webpack_public_path__ + "static/Elemental_Air-a9fe25e6e160991fdb5fc14da68c5a9a.jpg";